var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_78458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8729 30.5534H2.94626V8.63083H13.669V6.18457H0.5V32.9996H27.3191V19.8306H24.8729V30.5534Z",
    fill: "#1E3685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47266 27.0311H15.7847L33.5038 9.31208L24.1876 0L6.47266 17.7191V27.0311ZM8.91891 18.7302L20.5998 7.0493L25.2436 11.6931L26.9723 9.96442L22.3285 5.32061L24.1876 3.46145L30.0423 9.31616L14.7695 24.589H8.91484V18.7342L8.91891 18.7302Z",
    fill: "#1E3685"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_78458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrite);
export default __webpack_public_path__ + "static/media/icon_write.bc711f7a3ac1af28cf93850e2441da18.svg";
export { ForwardRef as ReactComponent };